import Rellax from 'rellax'
import scrollMonitor from 'scrollmonitor'

/**
 * Expand pictures from stack
 */
const expandPics = () => {
  const expandEvent = ($el) => {
    let el = $el[0],
      watcher = scrollMonitor.create(el, -700)

    watcher.one('enterViewport', () => {
      $el.find('.expand-pic').addClass('move-over')
    })
  }

  $('.block\\(about\\)').each(function() {
    expandEvent($(this))
  })
}

/**
 * Fade in text for textWithImage blocks.
 */
const fadeInText = () => {
  const fadeInEvent = ($el) => {
    let el = $el[0],
      watcher = scrollMonitor.create(el, -250)

    watcher.one('enterViewport', () => {
      $el.find('.faded').addClass('in-view')
    })
  }

  $('.block\\(about\\), .block\\(contact\\), .block\\(hero\\), .block\\(imageAndText\\), .block\\(cta\\), .block\\(quote\\)').each(function () {
    fadeInEvent($(this))
  })
}

const heroReveal = () => {
  setTimeout(() => {
    $('.fade-1').addClass('appear')
  }, 1000),
  setTimeout(() => {
    $('.fade-2').addClass('appear')
  }, 2000),
  setTimeout(() => {
    $('.fade-3').addClass('appear')
  }, 3000)
}

/** 
 * Add parallax functionality to decorations
 * @param {string} selector
 */
const initRellax = (selector) => {
  let decoration = document.querySelector(selector)
  if (decoration) {
    new Rellax(selector)
  }
}

/** 
 * Slide up Colors image in footer
 */
const slideUp = () => {
  const slideUpEvent = ($el) => {
    let el = $el[0],
      watcher = scrollMonitor.create(el, -250)

    watcher.one('enterViewport', () => {
      $el.find('.slide-up').addClass('see-me')
    })
  }

  $('.footer-bottom').each(function() {
    slideUpEvent($(this))
  })
}

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    expandPics()
    fadeInText()
    $(document).ready(() => {
      heroReveal()
    })
    initRellax('.parallax')
    slideUp()
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js